import React, { useRef } from 'react';
import { useDrag, useDrop } from 'react-dnd';

export const DraggableHeader = ({ index, moveTab, children }) => {
  const ref = useRef(null);

  const [, drag] = useDrag({
    type: 'TAB',
    item: { index },
  });

  const [, drop] = useDrop({
    accept: 'TAB',
    hover: item => {
      if (item.index !== index) {
        moveTab(item.index, index);
        item.index = index;
      }
    },
  });

  drag(drop(ref));

  return (
    <div ref={ref} className="cursor-move flex align-items-center gap-2">
      {children}
    </div>
  );
};
